import { useState, type ReactElement } from 'react';

import { applyTheme, getStoredTheme, nextTheme, type Theme } from '@/lib/theme';

export function ThemeToggle(): ReactElement {
  const [theme, setTheme] = useState<Theme>(() => getStoredTheme());

  const toggle = (): void => {
    const next = nextTheme(theme);
    applyTheme(next);
    setTheme(next);
  };

  const label = theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
  return (
    <button
      type="button"
      className="iconbtn"
      onClick={toggle}
      title="Cambiar tema (claro / oscuro)"
      aria-label={label}
      aria-pressed={theme === 'dark'}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none" />
      </svg>
    </button>
  );
}
